import { createSlice, type PayloadAction, type WithSlice } from '@reduxjs/toolkit';

import { DATAGRID_INITIAL_PAGE, DATAGRID_INITIAL_PAGE_SIZE } from '../../../common/constants';
import { rootReducer } from '../../../lib/store';

export interface AnnotatorProjectState {
  projectsListPage: number;
  projectsListPageSize: number;
}

const initialState: AnnotatorProjectState = {
  projectsListPage: DATAGRID_INITIAL_PAGE,
  projectsListPageSize: DATAGRID_INITIAL_PAGE_SIZE,
};

const annotatorProjectSlice = createSlice({
  name: 'annotatorProject',
  initialState,
  reducers: {
    setProjectsListPaginationModel: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>
    ) => {
      state.projectsListPage = action.payload.page;
      state.projectsListPageSize = action.payload.pageSize;
    },
  },
});

export const { setProjectsListPaginationModel } = annotatorProjectSlice.actions;

declare module '../../../lib/store' {
  // WithSlice utility assumes reducer is under slice.reducerPath
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof annotatorProjectSlice> {}
}

annotatorProjectSlice.injectInto(rootReducer);

export { annotatorProjectSlice };
